import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { CheckBox, TextCallout2 } from 'blocket-ui'
import styled from 'styled-components'
import ToolTip from 'components/ToolTip'
import { TextWrapper, Title, sharedToolTipStyles } from 'components/ToolTip/ToolTipStyles.js'
import { mediaQueries } from '@blazar-plugins/device'

const Wrapper = styled.div`
  padding-right: 10px;
  display: flex;
  align-items: center;
  @media ${mediaQueries.large} {
    padding-right: 20px;
  }

  &:last-child: {
    padding-right: 0;
  }
`

const ToolTipWrapper = styled.div`
  ${sharedToolTipStyles}
  top: 36px;
  left: -120px; /*  Desktop */
  &:after {
    content: '';
    width: 13px;
    height: 13px;
    left: 124px;
    top: -8px;
    -webkit-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }
`

const Text = styled(TextCallout2)`
  font-size: 12px;
  padding-left: 5px;
  max-width: 162px;
`

const BooleanFilter = ({
  label,
  currentQuery,
  queryKey,
  onChange,
  value = '1',
  children,
  isPremiumCheckTooltipEnabled,
}) => {
  const checked = currentQuery[queryKey] === value

  const ToolTipTitle = () => <Title>Bilen har Premiumgaranti</Title>
  const ToolTipText = () => {
    return (
      <TextWrapper>
        <Text>Erbjuder en utökad garanti och är extra noggrant kontrollerad</Text>
      </TextWrapper>
    )
  }

  const handleChange = useCallback(
    (e) => {
      onChange(e, queryKey, checked ? '' : value)
    },
    [queryKey, checked, onChange, value],
  )

  const additionalInfo =
    queryKey === 'pw' && isPremiumCheckTooltipEnabled ? (
      <ToolTip
        style={{ position: 'initial' }}
        ToolTipWrapper={ToolTipWrapper}
        title={<ToolTipTitle />}
        text={<ToolTipText />}
      >
        {children}
      </ToolTip>
    ) : (
      children
    )

  return (
    <Wrapper>
      <CheckBox
        label={label}
        checked={checked}
        onChange={handleChange}
        name={label}
        value={value}
        size="tiny"
      />
      &nbsp;
      <div>{additionalInfo}</div>
    </Wrapper>
  )
}

export default BooleanFilter

BooleanFilter.propTypes = {
  label: PropTypes.string.isRequired,
  currentQuery: PropTypes.object.isRequired,
  queryKey: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  children: PropTypes.node,
  isPremiumCheckTooltipEnabled: PropTypes.bool,
}
